import { render, staticRenderFns } from "./zone-purchase.vue?vue&type=template&id=513108f7&scoped=true"
import script from "./zone-purchase.vue?vue&type=script&lang=js"
export * from "./zone-purchase.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=513108f7&prod&scoped=true&lang=css&external"
import style1 from "./zone-purchase.vue?vue&type=style&index=1&id=513108f7&prod&scoped=true&lang=css"
import style2 from "./zone-purchase.vue?vue&type=style&index=2&id=513108f7&prod&lang=css"
import style3 from "./zone-purchase.vue?vue&type=style&index=3&id=513108f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513108f7",
  null
  
)

export default component.exports